export default __webpack_public_path__ + "static/media/Image 789.43ef824a.png";